import {useEffect} from "react";
import {useUnblockSlot} from "@App/hooks/graphql/mutations/useUnblockSlot";
import useStore from "@App/store"

export const useUnblockSlotOnMount = () => {

    const state = useStore()

    const slot = state.order.slot

    const {unblockSlot, loading, successful} = useUnblockSlot()

    useEffect(() => {
        if (slot && slot.id) {
            unblockSlot(slot)
        }
    }, [])

    return {
        successfullyUnblockedSlot: !slot || (!loading && successful)
    }
}


